import endPointConfig from './../endpoint/endpoint';
import numeral from 'numeral';
import { data_items_detail } from '../data/csv';

export const getEndpoint = (query) => {
    const {endPointURL, endPointURI} = endPointConfig;
    const endpoint = `${endPointURL}${endPointURI}?q=${query}`;
    return endpoint;
}

export const geomTable = (geoType) => { 
    const lookup = {
        'Local Government Area': 'lga',
        'Statistical Area 2': 'sa2',
        'Suburb': 'ssc'
    }
    return lookup[geoType];
}

export const makeDataTables = (inputArray) => {
    if (inputArray === undefined) {
        return []
    }
    const initObject = {
        title: inputArray[0].table_group,
        value: inputArray[0].table_group,
        key: `${inputArray[0].group_index}`,
        disabled: true,
        children: []
    }
    let outcome = [initObject];
    return inputArray.reduce((accumulator, currentValue, currentIndex, array) => {
        let newObj = {}, child = {};
        
        let children = [];
        child.title = currentValue.display_name
        child.value = currentValue.table_ending
        child.group = currentValue.table_group
        child.chart_order_clause = currentValue.chart_order_clause
        child.about_text = currentValue.about_text
        child.summary_heading = currentValue.summary_heading
        child.summary_content = currentValue.summary_content
        child.summary_sort = currentValue.summary_sort
        child.show_table_comparisons = currentValue.show_table_comparisons
        child.show_table_percentage = currentValue.show_table_percentage
        child.show_tab_summary = currentValue.show_tab_summary
        child.show_tab_chart = currentValue.show_tab_chart
        child.show_tab_table = currentValue.show_tab_table
        child.show_tab_about = currentValue.show_tab_about
        child.custom = currentValue.custom
        child.chart_heading = currentValue.chart_heading
        child.key= `${currentValue.group_index}-${currentValue.display_index}`
        children.push(child);
        newObj.children = children
        if(accumulator[currentValue.group_index] && accumulator[currentValue.group_index].title === currentValue.table_group) {
            let mergeArray = [...accumulator[currentValue.group_index].children, ...children]
            accumulator[currentValue.group_index].children = mergeArray;
        } else {
            const setupObject = {
                title: currentValue.table_group,
                value: currentValue.table_group,
                key: `${currentValue.group_index}`,
                disabled: true,
                children: children
            }
            outcome.push(setupObject)
        }
        return outcome;

      }, outcome);

}

export const groupBy = (objectArray, property) => {
    return objectArray.reduce(function (acc, obj) {
      var key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  }

export const setupOverviewData = (inputArray) => {

    if (inputArray === undefined) {
        return []
    }
    //format input first
    const notConvert = ['category', 'index', 'parent_level']
    const formatedByCurrency = inputArray.map((item)=> {
        let convertedValue = {}
        Object.entries(item).forEach(([childKey, childValue]) => {
            //console.log('childKey', childKey, 'childValue', childValue)
            if (!notConvert.includes(childKey)) {
                convertedValue[childKey] = numeral(childValue).format('$0,0.00')
            } else {
                convertedValue[childKey] = childValue
            }
            
        })
        return convertedValue
    })
    //console.log('formatedByCurrency', formatedByCurrency)    
    const group = groupBy(formatedByCurrency, 'parent_level')
    //console.log('group', group)
    let outcome = []
    const parents = group['parent']
    //console.log('parents', parents)
    
    Object.entries(parents).forEach(([key, value]) => {
        let children = group[value.category]

        let tmp = {
            ...value,
            children
        }
        
        //console.log('key',key, 'value', value, 'children', children, 'tmp', tmp)
        outcome.push(tmp)
    })

    //console.log('outcome', outcome)
    return outcome;
}

export const getTableTitle = (inputArray) => {
    return inputArray.map(item => {
        return item.title
    })
}

const inPlural = {
    'Suburb': 'Suburbs',
    'Statistical Area 2': 'SA2s'
}
export const getPlurals = (text)=> {
    return inPlural.hasOwnProperty(text) ? inPlural[text] : text;
}

export const getFormatTotal = (input, total) => {
    return input.map(item => {
        return { 
            total: numeral(item.total).format('0,0'),
            category: item.category,
            id: item.id,
            percentage: numeral(item.total/total).format('0.00%')
        } 
    })
}

export const getMapTotals = (inputArray) => {
    const brisbane = inputArray.find( (obj) => { 
        return obj.geo_name === "Brisbane (C)" 
    });
     
    
    if (inputArray.length === 0) {
        return { population_value: 0 }
    }
    if (inputArray.length ===1) {
        return {population_value: brisbane.population_value}
    }
    const input =  inputArray.reduce((a, b) => {
        return { population_value: a.population_value + b.population_value };
    })
    //console.log('brisbane', brisbane.population_value, 'total.population_value', total.population_value)
    return {population_value: input.population_value - brisbane.population_value} 
}

export const getTotals = (inputArray) => {
    if (inputArray.length === 0) {
        return { total: 0 }
    }
    return inputArray.reduce((a, b) => {
        return { total: a.total + b.total };
    })
}

export const getTotalByKey = (inputArray, key) => {
    if (inputArray.length === 0) {
        return { total: 0 }
    }
    return inputArray.reduce((a, b) => {
        return { total: a.total + b.total };
    })
}

export const addPercentage = (object, input) => {
    const percentage = numeral(object.population_value/input.population_value).format('0.00%');
    //console.log('addPercentage - object', object, 'input', input, 'percentage', percentage)
    return {
        ...object,
        percentage: percentage
    }
}

export const getPercentagePopUp = (geoType, percentage) => {
    const lookup = {
        'Local Government Area': '',
        'Statistical Area 2': percentage + ' of all SA2s',
        'Suburb': percentage + ' of all Suburbs'
    }
    return lookup[geoType];
} 

export const sortDesByValue = (inputArray, value) => {
    //need to create pure array/function otherwise it overrides original input array
    return [...inputArray].sort(function (a, b) {
        return numeral(b[value]).value() - numeral(a[value]).value()
      });
} 

export const replaceDbValues = (input) => {
    const output = input.data_table.about_text.replace(/db_population/g, input.population)
    .replace(/db_geo_name/g, input.geo_name)
    .replace(/db_geo_type/g, input.geo_type);

    return output
}

export const replaceDbValuesForTable = (dataObject, dataForSummary, orderArray) => {
    //console.log('replaceDbValuesForTable', 'dataObject', dataObject, 'dataForSummary', dataForSummary, 'orderArray', orderArray)
    let result = '', dbArray;
    if (dataForSummary.length === 0) {
        return result;
    } 
    result =    dataObject.data_table.summary_content.replace(/db_population/g, dataObject.population)
    .replace(/db_geo_name/g, dataObject.geo_name)
    .replace(/db_geo_type/g, dataObject.geo_type)
    .replace(/db_year/g, dataObject.year)
    .replace(/db_type/g, dataObject.type)

    //replace heading db_data.comparison0, db_data.comparison1 and db_data.comparison2
    if (orderArray !== undefined){
        orderArray.map((item, index) => {
            const comparisonHeading = `db_data.comparison${index}`
            result = result.replace(comparisonHeading, item)
            //console.log('comparionHeading', comparisonHeading, 'replaceValue', item)
        })
    }


    let createdArray = [];
    // Create nested array to map of db values
    dataForSummary.map( (dataItem, dataIndex) => {
        let tempArray = Object.keys(dataItem).map(typeItem => {
            return `db_data.${dataIndex}.${typeItem}`
        })
        createdArray.push(tempArray)
    })
    //console.log('createdArray', createdArray)
    // Flatten array
    dbArray = [].concat(...createdArray); 

    //console.log('dbArray', dbArray)
    // Replace with values
    dbArray.map(item => {
        let items = item.split('.')
        let index = items[1]
        let type = items[2]
        let replaceValue = dataForSummary[index][type]
        let regexp
        if(orderArray !== undefined && orderArray.includes(type)) {
            const indexNumber = orderArray.indexOf(type)
            const comparisonValue = `db_data.${index}.comparison${indexNumber}.value`
            //console.log('comparisonValue', comparisonValue)
            regexp = new RegExp(comparisonValue, 'g')
        } else {
            regexp  = new RegExp(item, 'g')
        }
        //console.log('index', index, 'type', type, 'replaceValue', replaceValue, 'item', item, 'regexp', regexp)
        result = result.replace(regexp, replaceValue)
    })
    //console.log('result', result)
    return result;

}

export const filterByCategory = (inputArray, inputObject) => {
    const results = inputArray.filter(item => {
        return item.category !== inputObject.category 
    })
    //console.log('results', results)
    return results
}

export const getDataOfTable = (tables, table) => {
    const results = tables.filter(item => {
        return item.table_ending === table
    })
    return results[0]
}

export const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const convertToNegativeValueOfArray = (inputArray) => {
    return inputArray.map( item =>  {
        return  item * (-1)
      });
}

export const rangeArray = (start, stop, step) => {
    return Array.from({ length: (stop - start) / step }, (_, i) => start + (i * step));
}
    
export const objectFromRange = (start, stop, step) => {
    const theRangeArray = rangeArray(start, stop, step)
    let obj= {}
    theRangeArray.map(item => {
        obj[item] = `${item}`
    })
    return obj
}
export const getTotalOfObject = (inputObject) => {
    let outcome = {}
    Object.entries(inputObject).forEach(([key, value]) => {
      outcome[key] =  Object.values(value).reduce((a, b) => a + b, 0)
      //console.log( 'key', key, 'value', value, 'outcome', outcome); 
    });
    //console.log( 'outcome', outcome); 
    return outcome;
}

export const getPercentageOfObject = (inputObject, totalObject) => {
    //console.log('inside getPercentageOfObject inputObject', inputObject, 'totalObject', totalObject)
    let outcome = {}
    Object.entries(inputObject).forEach(([key, value]) => {
      //outcome[key] =  
      let tmp = {}
      Object.entries(value).forEach(([childKey, childValue]) => {
          tmp[childKey] = numeral(childValue/totalObject[key]).format('0.00%')
        //console.log( 'childKey', childKey, 'childValue', childValue, 'totalObject[key]', totalObject[key], 'tmp', tmp); 
      })
      outcome[key] = tmp
      //console.log( 'key', key, 'value', value, 'totalObject', totalObject); 
    });
    //console.log( 'outcome', outcome); 
    return outcome;
}

export const mergeObjectToArray = (inputObject, inputArray) => {
    return inputArray.map( item => {
        //console.log('item', item, 'inputObject', inputObject)
        let tmp = {}
        Object.entries(inputObject).forEach(([key, value]) => {
            tmp[key] = value[item.category]
            //console.log( 'key', key, 'value', value, 'tmp', tmp); 
          });
        return {...item, ...tmp}
    })
}
export const setUpColumnObject = (title, name, sortedInfo, isStringSort, width) => {
    return {
        title: title,
        dataIndex: name,
        key: name,
        className: name,
        width: width || undefined,
        sorter: (a, b) => {
            if(isStringSort) {
                return (a[name] > b[name]) ? 1 : -1 
            } else {
                return numeral(a[name]).value() - numeral(b[name]).value()
            }
        },
        sortOrder: sortedInfo.columnKey === name && sortedInfo.order,
      }
}

export const isValidArray = (array) => {
    if (array === undefined) {
        return false
    }
    if(array && array.length === 0 ) {
        return false
    }

    return true
}
export const addIndirectImpact = (array, input) => {
    //console.log('array', array)
    if (array === undefined) {
        return []
    }
    if(array && array.length === 0 ) {
        return array
    }
    if (isNaN(input) || input === '' || input === '-') {
        return array
    }

    return array.map (item => {
        let indirect = numeral(item.multiplier * input).format('$0,0.00')
        //console.log('item', item, 'indirect', indirect)
        return {
            ...item,
            indirect
        }
    })
}

export const getSumObjectByColumn = (array, column) => {
    const validArray = isValidArray(array) ? array : []
    //console.log('validArray', validArray)
    let output = 0
    validArray.map(item => {
        //console.log(' numeral(array[column]).value()',  item[column])
        output = output + numeral(item[column]).value()
    })
    return output
}


// WEBPACK FOOTER //
// ./src/utils/utils.js